// CSS Modules - component class name prefix: HeaderBox__

<template>
  <div :class="$style.container">
    <div :class="$style.titleBox">
      <div :class="$style.type">{{ type }}</div>
      <h1>{{ title }}</h1>
      <div :class="$style.text">{{ text }}</div>
    </div>
    <div v-if="shopExtras" :class="$style.priceBox">
      <div :class="$style.priceTag">
        <strong>ab 62,28 €</strong>
        <span>
          zzgl. MwSt. &amp;
          <a href="#" target="_blank">Versand</a>
        </span>
      </div>
    </div>
    <div v-if="shopExtras" :class="$style.tabLinks">
      <Button
        colour="orange"
        text="Standardartikel"
        isTabLink
        tabID="standardarticle"
        href="#tabs"
      />
      <Button
        colour="blue"
        text="Konfigurator"
        isTabLink
        tabID="configurator"
        href="#tabs"
      />
    </div>
    <div :class="$style.docBox">
      <div :class="$style.subtitle">{{ subtitle }}</div>
      <div :class="$style.docLinkContainer">
        <a
          v-for="(link, index) in links"
          :class="$style.docLink"
          href="#"
          target="_blank"
          :key="index"
        >
          {{ link }}
        </a>
      </div>
      <div v-if="shopExtras" :class="$style.shopBox">
        <a :class="$style.shopLink" :href="shopExtras.url" target="_blank">
          <i class="fas fa-external-link-alt"></i>
          {{ shopExtras.linkText }}
        </a>
        <p>{{ shopExtras.deliveryNotice }}</p>
        <div v-if="warning" :class="$style.warningBox">
          <a :href="warning.url" target="_blank">
            <i class="fas fa-exclamation-triangle"></i>
            <strong>{{ warning.title }}</strong>
            <p>{{ warning.text }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../Button/Button";

export default {
  name: "HeaderBox",
  components: {
    Button
  },
  props: {
    type: String,
    title: String,
    text: String,
    subtitle: String,
    links: {
      type: Array,
      default: () => []
    },
    shopExtras: {
      type: Object,
      default: () => {}
    },
    warning: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style module lang="scss">
@import "./HeaderBox.scss";
</style>
